import {
  Avatar,
  Button,
  Card,
  DatePicker,
  Divider,
  Form,
  Input,
  List,
  message,
  Space,
  Tabs,
} from 'antd';
import { useNavigate } from 'react-router-dom';

// Internal
import Typography from '../../../components/Typography';
import useApi from '../../../hooks/useApi';
import { TODO } from '../../../types';
import { AnchorageSyncRequest } from '../../../services/api.interface';
import useProviders from '../../../utils/useProviders';

// Icons
import { ChevronRight } from 'react-feather';

// Lodash
import { get } from 'lodash-es';

// Styles
import styles from './sync.module.scss';
import sharedStyles from './shared.module.scss';

export interface SyncProps {
  onSync: TODO;
  onConnect?: TODO;
  selectedAccount?: any;
}

export default function SyncNew({ onSync, onConnect, selectedAccount }: SyncProps) {
  return (
    <>
      <div className={sharedStyles['wizard-content']}>
        {selectedAccount.name === 'Anchorage' && (
          <AnchorageSync onSync={onSync} onConnect={onConnect} selectedAccount={selectedAccount} />
        )}
        {selectedAccount.name !== 'Anchorage' && (
          <MetaMaskSync onSync={onSync} selectedAccount={selectedAccount} />
        )}
      </div>
    </>
  );
}

const list = [
  //   {
  //     name: 'Connect Wallet',
  //     description: 'Import data by using a browser wallet extension',
  //   },
  {
    name: 'Paste Address',
    description: 'Manually paste all of the wallet addresses',
  },
  {
    name: 'Import from File',
    description: 'Upload a CSV file will all of the addresses',
    csvImport: true,
  },
];

function MetaMaskSync({ onSync, selectedAccount }: SyncProps) {
  const handleCSVInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const csvFile = get(e, 'target.files[0]');

    const fileReader = new FileReader();
    if (csvFile) {
      fileReader.onload = function (event: TODO) {
        const csvContent = event.target.result;

        const addresses: object[] = [];

        csvContent
          .replace(/\s/g, '')
          .split(',')
          .forEach((d: string, i: number) => {
            if (i % 2 === 0) {
              addresses.push({ wallet_address: d });
            } else {
              addresses[addresses.length - 1] = {
                ...addresses[addresses.length - 1],
                name: d,
              };
            }
          });

        onSync(addresses);
      };

      fileReader.readAsText(csvFile);
    }
  };

  return (
    <div className={sharedStyles['wizard-content']}>
      <Space direction="vertical" align="center" size={8} className="fullwidth">
        <Avatar
          src={selectedAccount.image}
          size={45}
          style={{
            margin: '2rem 0 1.5rem 0',
          }}
        />
        <Typography type="text_lg" weight="medium">
          Sync with {selectedAccount.name}
        </Typography>

        <Typography type="text_sm" color="secondary" style={{ marginBottom: '2rem' }}>
          Choose how you want to import your {selectedAccount.name} addresses
        </Typography>
      </Space>

      <Card className={[sharedStyles.card, 'no-padding'].join(' ')}>
        <List
          className="demo-loadmore-list"
          itemLayout="horizontal"
          dataSource={list}
          renderItem={(item: TODO, index) => (
            <List.Item
              className={[sharedStyles['list-item'], styles['list-item']].join(' ')}
              onClick={item.csvImport !== true ? () => onSync(null) : undefined}
            >
              <Avatar
                size={{ xs: 45, sm: 45, md: 45, lg: 45, xl: 45, xxl: 45 }}
                src={selectedAccount.image}
              />

              <div className={styles['list-item__meta']}>
                <Typography type="text_sm" weight="medium">
                  {item.name}
                </Typography>

                <Typography type="text_sm" color="secondary">
                  {item.description}
                </Typography>
              </div>

              <div className="is-flex-grow-1"></div>

              <div className={styles['list-item__chevron']}>
                <ChevronRight />
              </div>

              {item.csvImport && (
                <input
                  type={'file'}
                  accept={'.csv'}
                  onChange={handleCSVInputChange}
                  multiple={false}
                />
              )}
            </List.Item>
          )}
        />
      </Card>
    </div>
  );
}

function AnchorageSync({ onSync, onConnect, selectedAccount }: SyncProps) {
  const [form] = Form.useForm();
  const api = useApi();

  const onFinish = () => {
    const request: AnchorageSyncRequest = {
      key: form.getFieldValue('apiKey'),
    };

    onConnect([
      {
        address: form.getFieldValue('apiKey'),
      },
    ]);
  };

  return (
    <>
      <Space direction="vertical" align="center" size={8} className="fullwidth">
        <Avatar
          size={45}
          src={selectedAccount.image}
          style={{
            margin: '2rem 0 1.5rem 0',
          }}
        />

        <Typography type="text_lg" weight="medium">
          Sync with Anchorage
        </Typography>

        <Typography type="text_sm" color="secondary" style={{ marginBottom: '2rem' }}>
          Connect your Anchorage API key to import the data
        </Typography>
      </Space>

      <Form id="SyncForm" layout="vertical" autoComplete="off" form={form} onFinish={onFinish}>
        <Form.Item
          name="apiKey"
          label="API Key"
          rules={[{ required: true, message: 'Please input API Key' }]}
        >
          <Input className={sharedStyles['wizard-imput']} />
        </Form.Item>
      </Form>
    </>
  );
}
